import { defineMessages } from 'react-intl';

const scopeConsentMessages = defineMessages({
  header: {
    id: 'scopeConsent.header',
    defaultMessage: 'Allow {appName} to access your account',
    description:
      'Header of the scope consent page. {appName} is the application requesting access.',
  },
  signedInAs: {
    id: 'scopeConsent.signedInAs',
    defaultMessage: 'Signed in as <b>{email}</b>. Not you? ',
    description: 'Text showing which account the user is signed in as.',
  },
  switchAccount: {
    id: 'scopeConsent.switchAccount',
    defaultMessage: 'Switch account',
    description:
      'Link to switch account, returning the user to the sign-in page.',
  },
  permissionsIntro: {
    id: 'scopeConsent.permissionsIntro',
    defaultMessage: 'This app will be able to:',
    description: 'Intro text above the list of permissions the app will have.',
  },
  permissionProfileTitle: {
    id: 'scopeConsent.permissionProfileTitle',
    defaultMessage: 'View your basic profile',
    description: 'Title of the basic profile permission.',
  },
  permissionProfileDescription: {
    id: 'scopeConsent.permissionProfileDescription',
    defaultMessage: 'Name, email address, and preferred language.',
    description: 'Description of the basic profile permission.',
  },
  permissionProgressTitle: {
    id: 'scopeConsent.permissionProgressTitle',
    defaultMessage: 'Read your learning progress',
    description: 'Title of the learning progress permission.',
  },
  permissionProgressDescription: {
    id: 'scopeConsent.permissionProgressDescription',
    defaultMessage: 'Enrolled courses, completion status, and learning plans.',
    description: 'Description of the learning progress permission.',
  },
  permissionCertificationsTitle: {
    id: 'scopeConsent.permissionCertificationsTitle',
    defaultMessage: 'View certifications and badges',
    description: 'Title of the certifications and badges permission.',
  },
  permissionCertificationsDescription: {
    id: 'scopeConsent.permissionCertificationsDescription',
    defaultMessage:
      'Earned AWS Certifications, digital badges, and exam history.',
    description: 'Description of the certifications and badges permission.',
  },
  permissionCatalogTitle: {
    id: 'scopeConsent.permissionCatalogTitle',
    defaultMessage: 'Search the Skill Builder catalog',
    description: 'Title of the catalog search permission.',
  },
  permissionCatalogDescription: {
    id: 'scopeConsent.permissionCatalogDescription',
    defaultMessage:
      'Recommend and link to courses, labs, and learning content.',
    description: 'Description of the catalog search permission.',
  },
  consentCheckbox: {
    id: 'scopeConsent.consentCheckbox',
    defaultMessage:
      'I allow {appName} to access my Skill Builder account as described above.',
    description:
      'Checkbox label the user must select to grant consent. {appName} is the requesting application.',
  },
  allowButton: {
    id: 'scopeConsent.allowButton',
    defaultMessage: 'Allow',
    description: 'Button to grant consent.',
  },
  cancelButton: {
    id: 'scopeConsent.cancelButton',
    defaultMessage: 'Cancel',
    description: 'Button to deny consent and return to the application.',
  },
  accessGrantedHeader: {
    id: 'scopeConsent.accessGrantedHeader',
    defaultMessage: 'Access granted',
    description: 'Header of the success alert shown after granting consent.',
  },
  accessGrantedBody: {
    id: 'scopeConsent.accessGrantedBody',
    defaultMessage: 'Your account is connected. Returning you to the app…',
    description: 'Body of the success alert shown after granting consent.',
  },
  legalText: {
    id: 'scopeConsent.legalText',
    defaultMessage:
      'Data is shared only to answer your requests in the connected app and is subject to its privacy policy. You can revoke access anytime from Account settings. By continuing, you agree to the <customerAgreementLink>AWS Customer Agreement</customerAgreementLink>, <privacyLink>Privacy Notice</privacyLink>, and <termsLink>AWS Learner Terms and Conditions</termsLink>.',
    description:
      'Legal disclaimer text shown at the bottom of the consent screen.',
  },
});

export default scopeConsentMessages;
